// `extract.colors`: a picture's colors (spec G15c-colors-from-image). The product form's
// "Re-extract from Image" starts it and takes its answer as the product's colors; live lists no
// such job, and a Studio draft never holds one.
import { ExtractColorsQuote, ExtractColorsRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"extract.colors"> = {
  type: "extract.colors",
  label: "Colors from an image",
  source: "form",
  pair: "extract.colors",
  fields: () => ({}),
  request: ExtractColorsRequest,
  quote: ExtractColorsQuote,
};
